import Dashboard from '@/views/layouts/Dashboard'
import Login from '@/views/Login'
import Category from '@/views/Category'
import Subcategory from '@/views/Subcategory'
import Filter from '@/views/Filter'
import Ranges from '@/views/Ranges'
import Decks from '@/views/Decks'

export default [
  { path: '/login', name: 'login_path', component: Login },
  {
    path: '/',
    component: Dashboard,
    children: [
      {
        path: '', component: Category, name: 'home'
      },
      {
        path: 'decks', component: Decks, name: 'decks_path'
      },
      {
        path: ':categoryId', component: Subcategory, name: 'subcategories_path'
      },
      {
        path: ':categoryId/s/:subcategoryId', component: Filter, name: 'filters_path'
      },
      {
        path: ':categoryId/s/:subcategoryId/f/:filterId', component: Ranges, name: 'ranges_path'
      }
    ]
  }
]
